import { Badge, Button } from 'antd'
import { EditOutlined } from '@ant-design/icons'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FalseIcon, TrueIcon } from '../../utils/commonIcons'
import { DrawerBtn, CreateUserComment, ViewUserSalary, ViewUserSuspending, UserUnSuspending, EditUserInfo as UpdateUserInfo, ViewEditApprovedUserSInfo, ViewUpdateBankInfo, UpdateUserCaps, ViewAssignUser } from '@operations/shared';
import helper from '../../utils/helper'
import { updateIsViewUserAction } from '../../stores/actions';
import moment from 'moment';
import { UserTag } from '../../utils/commonInterfaces';
import { MeezaCardStatus } from '../../utils/commonInterfaces';
import { getRegion } from '../../components/regionWrapper';
import { Region } from '../../utils/commonInterfaces';

type InfoRow = { key: string; value: any };

type SectionConfig = {
    key: string;
    title: string;
    nav: string;
    data?: InfoRow[];
    nonEditable?: boolean;
    action?: any;
    actionName?: string;
    drawerTitle?: string;
};

const isBlank = (value: any) =>
    value === null || value === undefined || value === '' || value === 'NA' || value === 'N/A';

const renderFieldValue = (value: any) => {
    if (React.isValidElement(value)) return value;
    if (isBlank(value)) {
        return <span className="user-dossier__na">{value === 'N/A' ? 'N/A' : 'NA'}</span>;
    }
    return <span className="user-dossier__value">{value}</span>;
};

const readRow = (rows: InfoRow[] | undefined, key: string) =>
    rows?.find((row) => row.key === key)?.value;

interface Props {
    info?: {
        userID: number,
        name: string,
        companyName: string,
        city?: string,

        phone: string,
        email: string,

        consent: [],
        nationalId: any,
        hrLetter: [],
        accountCreatedAt: string,
        bankAccountHolderName: string,
        bankAccountHolderNameEn: string,
        bankAccountNumber: string,
        bankName: string,

        userStatus: string,
        userStatusType: string,

        maxAdvancePercentAllowedPerCompany: number,
        maxBalance: number,
        maxShoppingBalnce: number,

        wallet: number,
        staff_id: string,
        companyMaxInstallmentCount: number,
        nationalIDNumber: string,
        netSalary: any,
        hiringDate: string,
        jobTitle: string,
        hasMeezaCard: number,
        department: any,
        suspensionStatus?: {
            comment: string,
            date: string,
            isSuspended: boolean,
            reason: string
        },
        accountCreatedOn: string,
        status: string,
        statusReason: string,
        outstandingAmount: number,
        myBalance: number,
        currentBalance:number,
        rewardBalance: number,
        dbr: number,
        maxMonthlyRequestsLimit: number,
        vipFreeMonths: number,
        vipFreeMonthsStartDate: number,
        vipFreeMonthsEndDate?: string,
        vipMinFreeInstallments?: number,
        appVersion: string,
        platform: string,
        comment: string,
        onGoingAdvancesPercentThreshold: number,
        onGoingAdvancesRequests: number,
        userStatusTypeID: number,
        companyBranch?: {
            id: number | null,
            name: string,
            nameAr: string,
        },
        vipMaxAmount?: number | null,
        userTags?: UserTag[],
        userMaxAdvanceAllowedPercent?: number | null,
        departmentMaxAdvanceAllowedPercent?: number | null,
        companyMaxAdvanceAllowedPercent?: number | null,
        activeMaxAdvanceAllowedPercent?: number | null,
        endOfServiceBenefit?: number | null,
        userProbationPeriod?: number | null,
        departmentProbationPeriod?: number | null,
        companyProbationPeriod?: number | null,
        userMaxInstallments?: number | string | null,
        requestRequiredHRApproval?: boolean,
        userRequestRequiredHRApproval?: boolean,
        departmentRequestRequiredHRApproval?: boolean,
        companyRequestRequiredHRApproval?: boolean,

    },
    updateIsViewUserAction: any,
}

class UserInfo extends Component<Props> {
    region = getRegion();
    regionCurrency = this.region === Region.EG ? 'EGP' : 'SAR';
    buildUserStateFromProps = (info: Props["info"]) => {
        return {
        basicInfo: [
            { key: 'User ID', value: this.props.info?.userID ? this.props.info.userID : 'NA' },
                { key: 'Name', value: this.props.info?.name ? this.props.info?.name : 'NA' },
            { key: 'Company', value: this.props.info?.companyName ? this.props.info?.companyName : 'NA' },
            ...(this.region === Region.SE ? [{ key: 'City', value: this.props.info?.city ? this.props.info?.city : 'NA' }] : []),
            ...(this.props.info?.companyBranch?.name && this.region === Region.EG ? [{ key: 'Branch', value: this.props.info?.companyBranch?.name }] : []),
            { key: 'Staff ID', value: this.props.info?.staff_id ? this.props.info?.staff_id : 'NA' },
            { key: 'Job Title', value: this.props.info?.jobTitle ? this.props.info?.jobTitle : 'NA' },
            { key: 'Department', value: this.props.info?.department?.nameEn ? this.props.info?.department?.nameEn : 'NA' },
            { key: 'Account Created On', value: this.props.info?.accountCreatedAt ? helper.changeDateFormat(this.props.info?.accountCreatedAt) : 'NA' },
            { key: 'Hiring Date', value: this.props.info?.hiringDate ? moment(this.props.info?.hiringDate).format('YYYY-MM-DD') : 'NA' },
                { key: 'Request Approval Required', value: this.props.info?.requestRequiredHRApproval ? TrueIcon : FalseIcon },
                { key: 'User Request Approval Required', value: this.props.info?.userRequestRequiredHRApproval ? TrueIcon : FalseIcon },
                { key: 'Department Request Approval Required', value: this.props.info?.departmentRequestRequiredHRApproval ? TrueIcon : FalseIcon },
                { key: 'Company Request Approval Required', value: this.props.info?.companyRequestRequiredHRApproval ? TrueIcon : FalseIcon },
            { key: 'User Maximum Installments', value: this.props.info?.userMaxInstallments ? this.props.info?.userMaxInstallments : 'NA' },
            { key: 'Company Maximum Installments', value: this.props.info?.companyMaxInstallmentCount ? this.props.info?.companyMaxInstallmentCount : 'NA' },
            {
                key: 'Status', value: this.props.info?.userStatus ? <Badge color={this.props.info?.userStatus.includes('Active') ? "green" : 'grey'}
                    status={this.props.info?.userStatus.includes('Active') ? "processing" : 'default'} text={this.props.info?.userStatus} /> : 'NA'
            },
                { key: 'Status Reason', value: this.props.info?.userStatusType ? this.props.info?.userStatusType : 'NA' },
            ...(this.props.info?.userTags && this.region === Region.EG ? this.props.info?.userTags?.map((tag: UserTag) => ({ key: tag?.categoryName, value: tag?.tagName })) : []),
            ...(this.region === Region.SE ? [
                { key : 'User Probation Period' , value: this.props.info?.userProbationPeriod ?? 'NA' },
                { key : 'Department Probation Period' , value: this.props.info?.departmentProbationPeriod ?? 'NA' },
                { key : 'Company Probation Period' , value: this.props.info?.companyProbationPeriod ?? 'NA' }]
                : []),
        ],
        personalInfo: [
            { key: 'Phone', value: this.props.info?.phone ? this.props.info?.phone : 'NA' },
            { key: 'Email', value: this.props.info?.email ? this.props.info?.email : 'NA' },
            { key: 'National ID', value: this.props.info?.nationalIDNumber ? this.props.info?.nationalIDNumber : 'NA' }
        ],
        bankInfo: [
            { key: 'Bank Name', value: this.props.info?.bankName ? this.props.info?.bankName : 'NA' },
            { key: 'Bank Account holder Name', value: this.props.info?.bankAccountHolderName ? this.props.info?.bankAccountHolderName : 'NA' },
            { key: 'Bank Account holder Name (English)', value: this.props.info?.bankAccountHolderNameEn ? this.props.info.bankAccountHolderNameEn : 'NA' },
            { key: 'Bank Account Number', value: this.props.info?.bankAccountNumber ? this.props.info?.bankAccountNumber : 'NA' },
            { key: 'Meeza Card Status', value: this.props.info?.hasMeezaCard === MeezaCardStatus.requested ? 'Requested' : this.props.info?.hasMeezaCard === MeezaCardStatus.recievied ? 'Received' : 'NA' },
        ],
    
        salaryInfo: [
            { key: 'Net Salary', value: this.props.info?.netSalary ? `${helper.amountFormatter(this.props.info?.netSalary)} ${this.regionCurrency}` : 'NA' },
            ...(this.region === Region.SE ? [
                { key: 'User Maximum Advance Percentage Allowed', value: this.props.info?.userMaxAdvanceAllowedPercent ? this.props.info?.userMaxAdvanceAllowedPercent : 'N/A' },
                { key: 'Department Maximum Advance Percentage Allowed', value: this.props.info?.departmentMaxAdvanceAllowedPercent ? this.props.info?.departmentMaxAdvanceAllowedPercent : 'N/A' },
                { key: 'Company Maximum Advance Percentage Allowed', value: this.props.info?.companyMaxAdvanceAllowedPercent ? this.props.info?.companyMaxAdvanceAllowedPercent : 'N/A' },
                { key: 'Active Maximum Advance Percentage Allowed', value: this.props.info?.activeMaxAdvanceAllowedPercent ? this.props.info?.activeMaxAdvanceAllowedPercent : 'N/A' },
                { key: 'End of Service Payment', value: this.props.info?.endOfServiceBenefit ? `${helper.amountFormatter(this.props.info?.endOfServiceBenefit)}` : 'N/A' },
            ] : []),
        ],
        balanceInfo: [
            { key: 'Current Balance', value: this.props.info?.currentBalance ? `${helper.amountFormatter(this.props.info?.currentBalance)} ${this.regionCurrency}` : 'NA' },
            { key: 'Maximum Balance', value: this.props.info?.maxBalance ? `${helper.amountFormatter(this.props.info?.maxBalance)} ${this.regionCurrency}` : 'NA' },
            { key: 'Outstanding Amount', value: this.props.info?.outstandingAmount ? `${helper.amountFormatter(this.props.info?.outstandingAmount)} ${this.regionCurrency}` : 'NA' },
            { key: 'Reward Balance', value: this.props.info?.rewardBalance ? `${helper.amountFormatter(this.props.info?.rewardBalance)} ${this.regionCurrency}` : 'NA' },
            { key: 'DBR', value: this.props.info?.dbr ? this.props.info?.dbr : 'NA' },
    
        ],
        requestLimitationInfo: [
            { key: 'Maximum Active Requests Allowed', value: this.props.info?.onGoingAdvancesRequests ? this.props.info?.onGoingAdvancesRequests : 'NA' },
            { key: 'Maximum Active Requests Percentage Allowed', value: this.props.info?.onGoingAdvancesPercentThreshold ? this.props.info?.onGoingAdvancesPercentThreshold : 'NA' },
            { key: 'Monthly Requests Limit', value: this.props.info?.maxMonthlyRequestsLimit ? this.props.info?.maxMonthlyRequestsLimit : 'NA' }
    
        ],
        companyConfigInfo: [
            { key: 'Suspended Service Groups', value: this.props.info?.phone ? 'Maximum Active Requests Allowed' : 'NA' },
            { key: 'Maximum Advance', value: this.props.info?.maxAdvancePercentAllowedPerCompany ? this.props.info?.maxAdvancePercentAllowedPerCompany : 'NA' },
            { key: 'Maximum Shopping Balance', value: this.props.info?.maxMonthlyRequestsLimit ? this.props.info?.maxMonthlyRequestsLimit : 'NA' },
            { key: 'Maximum Balance', value: this.props.info?.phone ? 'Maximum Active Requests Allowed' : 'NA' },
            { key: 'Free Period on Deductions', value: this.props.info?.maxAdvancePercentAllowedPerCompany ? this.props.info?.maxAdvancePercentAllowedPerCompany : 'NA' },
            { key: 'Free Period Expiry Date', value: this.props.info?.maxMonthlyRequestsLimit ? this.props.info?.maxMonthlyRequestsLimit : 'NA' }
        ],
        vipUserInfo: [
            ...(this.region === Region.EG ? [
            { key: 'Number of Free Months', value: this.props.info?.vipFreeMonths ? this.props.info?.vipFreeMonths : 'NA' },
            { key: 'Start Date', value: this.props.info?.netSalary && this.props.info?.vipFreeMonthsStartDate ? `${helper.changeDateFormat(this.props.info?.vipFreeMonthsStartDate)}` : 'NA' },
            { key: 'End Date', value: this.props.info?.netSalary && this.props.info?.vipFreeMonthsEndDate ? `${helper.changeDateFormat(this.props.info?.vipFreeMonthsEndDate)}` : 'NA' },
            { key: 'Minimum Number of Installments', value: this.props.info?.vipMinFreeInstallments ? this.props.info?.vipMinFreeInstallments : 'NA' },
            { key: 'Max Allowed Amount', value: !this.props.info?.vipMaxAmount && this.props.info?.vipFreeMonthsStartDate ? 'Unlimited' : this.props.info?.vipFreeMonthsStartDate ? this.props.info?.vipMaxAmount : 'NA' }
            ] : []),
            ...(this.region === Region.SE ? [            
                { key: 'Number of Free Months', value: this.props.info?.vipFreeMonths && this.props.info?.vipFreeMonths },
                { key: 'Start Date', value: this.props.info?.netSalary ? `${helper.changeDateFormat(this.props.info?.vipFreeMonthsStartDate)}` : 'NA' }
    ] : [])
        ],
        suspensionStatusInfo: [
            { key: 'Suspended', value: this.props.info?.suspensionStatus?.isSuspended ? TrueIcon : FalseIcon },
            { key: 'Suspended On', value: this.props.info?.suspensionStatus?.date ? helper.changeDateFormat(this.props.info?.suspensionStatus.date) : 'NA' },
            { key: 'Comment', value: this.props.info?.suspensionStatus?.comment ? this.props.info?.suspensionStatus.comment : 'NA' }
    
        ],
        systemInfo: [
            { key: 'App Version', value: this.props.info?.appVersion ? this.props.info?.appVersion : 'NA' },
            { key: 'Last Login', value: this.props.info?.platform ? this.props.info?.platform : 'NA' },
            { key: 'Platform', value: this.props.info?.platform ? this.props.info?.platform : 'NA' }
    
        ],
        commentInfo: [
            { key: 'Comment', value: this.props.info?.comment ? this.props.info?.comment : 'NA' },
    
        ]
        };
    };

    state = {
        ...this.buildUserStateFromProps(this.props.info),
        activeSection: 'basic',
    };

    componentDidMount(): void {
        this.props.updateIsViewUserAction(true)
    }

    componentWillUnmount(): void {
        this.props.updateIsViewUserAction(false)
    }

    componentDidUpdate(nextProps: Readonly<Props>): void {
        if (nextProps.info !== this.props.info) {
            this.setState(this.buildUserStateFromProps(this.props.info));
        }
    }

    selectSection = (key: string) => {
        this.setState({ activeSection: key })
    }

    renderEdit = (section: SectionConfig) => {
        if (section.nonEditable || !section.action || !section.actionName) return null;
        return (
            <div className="user-dossier__edit">
                <DrawerBtn
                    drawerTitle={section.drawerTitle || ''}
                    actionName={section.actionName}
                    action={section.action}
                >
                    <Button type="text" size="small" icon={<EditOutlined />}>Edit</Button>
                </DrawerBtn>
            </div>
        );
    };

    renderSection = (section: SectionConfig) => (
        <section className="user-dossier__section" key={section.key}>
            <div className="user-dossier__section-head">
                <h3 className="user-dossier__section-title">{section.title}</h3>
                {this.renderEdit(section)}
            </div>
            {section.data?.length ? (
                <div className="user-dossier__fields">
                    {section.data.map((row, index) => (
                        <div
                            className={`user-dossier__field${section.data && section.data.length === 1 ? ' is-wide' : ''}`}
                            key={`${row.key}-${index}`}
                        >
                            <span className="user-dossier__label">{row.key}</span>
                            {renderFieldValue(row.value)}
                        </div>
                    ))}
                </div>
            ) : (
                <div className="user-dossier__empty">No details</div>
            )}
        </section>
    );

    render() {
        const { info } = this.props;
        if (!info) return null;

        const isActive = !!info.userStatus?.includes('Active');
        const isSuspended = !!info.suspensionStatus?.isSuspended;
        const profileEdit = info.userStatusTypeID === 1
            ? {
                action: <ViewEditApprovedUserSInfo />,
                actionName: 'updateApprovedUserInfo',
                drawerTitle: 'Change approved Users Info',
            }
            : {
                action: <UpdateUserInfo />,
                actionName: 'updateUserInfo',
                drawerTitle: 'Update User Information',
            };
        const subtitle = [
            info.companyName,
            info.jobTitle,
            info.staff_id ? `Staff ${info.staff_id}` : null,
        ].filter(Boolean).join(' · ');

        const sections: SectionConfig[] = [
            { key: 'basic', nav: 'Basic', title: 'Basic Information', data: this.state.basicInfo, ...profileEdit },
            { key: 'personal', nav: 'Personal', title: 'Personal Information', data: this.state.personalInfo, ...profileEdit },
            { key: 'bank', nav: 'Bank', title: 'Bank Information', data: this.state.bankInfo, action: <ViewUpdateBankInfo />, actionName: 'updateBankInfo', drawerTitle: 'User Bank Information' },
            { key: 'salary', nav: 'Salary', title: 'Salary Information', data: this.state.salaryInfo, action: <ViewUserSalary />, actionName: 'updateUserSalary', drawerTitle: 'User Salary' },
            { key: 'balance', nav: 'Balance', title: 'Balance', data: this.state.balanceInfo, nonEditable: true },
            { key: 'caps', nav: 'Caps', title: 'Request Limitations (CAPS)', data: this.state.requestLimitationInfo, action: <UpdateUserCaps />, actionName: 'updateUserCap', drawerTitle: 'Update User Services Cap' },
            { key: 'vip', nav: 'VIP', title: 'VIP User', data: this.state.vipUserInfo, action: <ViewAssignUser />, actionName: 'assignUserToFeesModel', drawerTitle: 'Assign VIP User' },
            {
                key: 'suspension',
                nav: 'Suspension',
                title: 'Suspension Status',
                data: this.state.suspensionStatusInfo,
                action: !isSuspended ? <ViewUserSuspending /> : <UserUnSuspending />,
                actionName: !isSuspended ? 'suspendUser' : 'unSuspendUser',
                drawerTitle: !isSuspended ? 'Suspend User' : 'Un-Suspend User',
            },
            { key: 'system', nav: 'System', title: 'System Information', data: this.state.systemInfo, nonEditable: true },
            { key: 'comment', nav: 'Comment', title: 'General Comment', data: this.state.commentInfo, action: <CreateUserComment />, actionName: 'userCreateSingleComment', drawerTitle: 'Add User Comment' },
        ];
        const selected = sections.find((section) => section.key === this.state.activeSection) || sections[0];
        const facts = [
            { label: 'Current balance', value: readRow(this.state.balanceInfo, 'Current Balance'), tone: 'is-primary' },
            { label: 'Outstanding', value: readRow(this.state.balanceInfo, 'Outstanding Amount'), tone: 'is-alert' },
            { label: 'Net salary', value: readRow(this.state.salaryInfo, 'Net Salary'), tone: '' },
            { label: 'DBR', value: readRow(this.state.balanceInfo, 'DBR'), tone: '' },
        ];

        return (
            <div className="user-dossier">
                <header className="user-dossier__header">
                    <div>
                        <div className="user-dossier__name">{info.name || 'NA'}</div>
                        <div className="user-dossier__meta">{subtitle || 'NA'}</div>
                        <div className="user-dossier__meta">
                            <span>{info.phone || 'NA'}</span>
                            <span>{info.email || 'NA'}</span>
                            <span>User {info.userID || 'NA'}</span>
                        </div>
                    </div>
                    <div className="user-dossier__chips">
                        <span className={`user-dossier__chip ${isActive ? 'is-ok' : 'is-bad'}`}>{info.userStatus || 'Unknown status'}</span>
                        <span className={`user-dossier__chip ${isSuspended ? 'is-warn' : 'is-ok'}`}>{isSuspended ? 'Suspended' : 'Not suspended'}</span>
                    </div>
                </header>

                <div className="user-dossier__facts">
                    {facts.map((fact) => {
                        const blank = isBlank(fact.value);
                        return (
                            <div className={`user-dossier__fact ${blank ? '' : fact.tone}`} key={fact.label}>
                                <span className="user-dossier__fact-label">{fact.label}</span>
                                <span className="user-dossier__fact-value">{blank ? 'NA' : fact.value}</span>
                            </div>
                        );
                    })}
                </div>

                <nav className="user-dossier__nav" aria-label="Profile sections">
                    {sections.map((section) => {
                        const selectedTab = section.key === selected.key
                        return (
                            <button
                                type="button"
                                key={section.key}
                                aria-pressed={selectedTab}
                                className={`user-dossier__jump${selectedTab ? ' is-active' : ''}`}
                                onClick={() => this.selectSection(section.key)}
                            >
                                {section.nav}
                            </button>
                        )
                    })}
                </nav>

                {sections.map((section) => (
                    <div key={section.key} hidden={section.key !== selected.key}>
                        {this.renderSection(section)}
                    </div>
                ))}
            </div>
        )
    }
}
const mapStateToProps = (state: any) => ({
    info: state.actionsReducer.info,
})
export default connect(mapStateToProps, { updateIsViewUserAction })(UserInfo)